<template>
  <div
    id="form-search-popover"
    class="component-card container-app-search">
    <j-title-header :options="title"/>

    <v-server-table
      v-show="load_first"
      ref="tableServer"
      :columns="columns"
      :options="options"
      class="jTable"
      @loading="loading"
      @loaded="loaded"
      @row-click="openEditModal">
      <div
        slot="beforeFilter"
        class="custom-search">
        <b-form inline>
          <b-button
            v-if="!readOnly"
            class="btn grey btn-import-form m__r--5"
            @click="openCreateModal">
            <i class="fa fa-plus fa-lg"/> Add
          </b-button>
          <b-button
            class="btn grey btn-import-form m__r--5"
            @click="exportData">
            <i class="fa fa-download fa-lg"/> Export
          </b-button>

          <b-form
            inline
            @keypress.13.prevent="filter()">
            <j-select
              v-model="select_type"
              :options="options_search"
              placeholder="Filter By"
              class="m__r--5"/>
            <b-form-input
              v-model="filter_data"
              placeholder="Search"
              style="width: 250px !important; height: 33px;"/>
          </b-form>
        </b-form>
      </div>
    </v-server-table>
    <jLoadingTable v-if="!load_first"/>

    <b-modal
      ref="modalCreate"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Create Data</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_mitra.mitra.$error}">
            <label> Mitra </label>
            <j-input
              v-model="$v.data_mitra.mitra.$model"
              placeholder="Mitra"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_mitra.alamat.$error}">
            <label> Alamat </label>
            <j-textarea
              v-model="$v.data_mitra.alamat.$model"
              placeholder="Alamat"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_mitra.telp.$error}">
            <label> Telepon </label>
            <j-input
              v-model="$v.data_mitra.telp.$model"
              placeholder="Telepon"
              type="number"/>
          </b-form-group>
        </b-col>
      </b-row>

      <div class="float-to-right m__t--20">
        <b-button
          class="btn blue m__r--5"
          @click="saveData">
          Save
        </b-button>
        <b-button
          class="btn gray"
          @click="closeModalCreate">
          Cancel
        </b-button>
      </div>
    </b-modal>

    <b-modal
      ref="modalUpdate"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Update Data</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_mitra.mitra.$error}">
            <label> Mitra </label>
            <j-input
              v-model="$v.data_mitra.mitra.$model"
              :disabled="readOnly"
              placeholder="Mitra"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_mitra.alamat.$error}">
            <label> Alamat </label>
            <j-textarea
              v-model="$v.data_mitra.alamat.$model"
              :disabled="readOnly"
              placeholder="Alamat"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_mitra.telp.$error}">
            <label> Telepon </label>
            <j-input
              v-model="$v.data_mitra.telp.$model"
              :disabled="readOnly"
              placeholder="Telepon"
              type="number"/>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="3">
          <b-button
            v-if="!readOnly"
            class="btn red m__t--20"
            @click="deleteData">
            Delete
          </b-button>
        </b-col>
        <b-col md="9">
          <div class="float-to-right m__t--20">
            <b-button
              v-if="!readOnly"
              class="btn blue m__r--5"
              @click="updateData">
              Update
            </b-button>
            <b-button
              class="btn gray"
              @click="closeModalUpdate">
              Cancel
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { jPrivRoles } from '@/privilage/roles/jPrivRoles';

import jApiHubin from '@/services/jApiHubin';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';

export default {
  components: {
    jLoadingTable,
  },
  mixins: [
    jPrivRoles,
  ],
  data() {
    return {
      title: {
        icon: 'fa-file',
        main_title: 'Data Mitra',
      },

      data_mitra: {
        mitra: '',
        alamat: '',
        telp: '',
      },
      filter_data: '',
      select_type: 'mitra',
      options_search: [
        {
          text: 'Mitra',
          value: 'mitra',
        },
      ],
      load_first: false,
      data_table: [],
      columns: ['id', 'mitra', 'alamat', 'telp'],
      options: {
        headings: {
          id: 'ID',
          mitra: 'MITRA',
          alamat: 'ALAMAT',
          telp: 'TELEPON',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: [],
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],
        requestAdapter(data) {
          return {
            mitra: data.mitra,
            limit: data.limit,
            page: data.page,
          };
        },
        requestFunction(data) {
          const getList = jApiHubin.getListMitra(data);
          return getList.catch((e) => {
            this.$store.dispatch('jStoreNotificationScreen/getProblemMessage', e.response.data.errors[0].message).bind(this);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length ? data.length : 0,
          };
        },
      },
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem']),
    ...mapActions('jStoreHubin', ['createMitra', 'updateMitra', 'deleteMitra', 'exportMitra']),

    loading(val) {
      const a = val;
      a.mitra = this.filter_data;

      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded(data) {
      this.data_table = data.data.data;

      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    filter() {
      this.$refs.tableServer.getData();
    },

    openCreateModal() {
      this.$refs.modalCreate.show();
    },

    closeModalCreate() {
      this.$refs.modalCreate.hide();
      this.data_mitra = {
        mitra: '',
        alamat: '',
        telp: '',
      };
      setTimeout(() => {
        this.$v.data_mitra.$reset();
      }, 1000);
    },

    closeModalUpdate() {
      this.$refs.modalUpdate.hide();
      this.data_mitra = {
        mitra: '',
        alamat: '',
        telp: '',
      };
      setTimeout(() => {
        this.$v.data_mitra.$reset();
      }, 1000);
    },

    openEditModal(param) {
      this.$refs.modalUpdate.show();
      this.data_mitra = {
        id: param.row.id,
        mitra: param.row.mitra,
        alamat: param.row.alamat,
        telp: param.row.telp,
      };
    },

    saveData() {
      this.$v.data_mitra.$touch();
      if (!this.$v.data_mitra.$error) {
        this.createMitra(this.data_mitra).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$refs.tableServer.getData();
              this.closeModalCreate();
            }, 1500);
          }
        });
      }
    },

    updateData() {
      this.$v.data_mitra.$touch();
      if (!this.$v.data_mitra.$error) {
        this.updateMitra(this.data_mitra).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$refs.tableServer.getData();
              this.closeModalUpdate();
            }, 1500);
          }
        });
      }
    },

    deleteData() {
      this.$swal({
        title: 'Delete Data',
        text: 'Are you sure want to delete this data?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const param = {
            id: this.data_mitra.id,
          };
          this.deleteMitra(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$refs.tableServer.getData();
                this.closeModalUpdate();
              }, 1500);
            }
          });
        }
      });
    },

    exportData() {
      const params = {
        mitra: this.filter_data,
        limit: '10000000',
        page: '1',
      };
      this.exportMitra(params).then((res) => {
        window.location.href = res.data.data.url;
      });
    },
  },
  validations() {
    return {
      data_mitra: {
        mitra: { required },
        alamat: { required },
        telp: { },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/hubungan-dinas/mitra/jMitraList.vue